import React, {useMemo} from 'react';
import NxNumberInput from '../../nxNumberInput/NxNumberInput';
import {CashMaskWrapper} from './CashMaskWrapper';

export interface NxCashInputProps {
  className?: string;
  currency?: string;
  disabled?: boolean;
  error?: string;
  id?: string;
  label: React.ReactNode;
  name?: string;
  onBlur?: () => void;
  onChange?: (value: number | null) => void;
  positionAbsoluteError?: boolean;
  value?: number | null;
  required?: boolean;
  decimals? : number
}

// undefined clears input
const NxCashInput = (
    {
      className,
      currency = 'PHP',
      disabled = false,
      error,
      id,
      label,
      name,
      onBlur,
      onChange,
      positionAbsoluteError,
      required,
      decimals = 2,
      value
    }: NxCashInputProps
  ): React.ReactElement => {

  const endAdornment = <>{currency}</>;
  const MaskComponent = useMemo(() => CashMaskWrapper(decimals), [decimals]);

  return (
    <NxNumberInput className={className}
                   disabled={disabled}
                   error={error}
                   id={id}
                   onBlur={onBlur}
                   onChange={onChange}
                   endAdornment={endAdornment}
                   label={label}
                   name={name}
                   required={required}
                   positionAbsoluteError={positionAbsoluteError}
                   step={Math.pow(10, -decimals)}
                   inputComponent={MaskComponent}
                   showArrows={false}
                   value={value} />
  );
};

export default NxCashInput;
